import {
  Errors as PaymentPluginErrors,
  ErrorUserMessages as PaymentPluginErrorUserMessages,
} from '@based/payment-plugin/shared'

export enum NvpErrorUserMessages {
  CantConfirmCardCountry = 'Cannot confirm card country origin',
  CardOrWalletAlreadyVotedInSequence = 'Card has already voted in this sequence',
  CaptchaError = "There was an error confirming you're not a bot",
}

export enum NvpErrors {
  InvalidRequestPaymentPayload = 'invalid_request_payment_payload',
  InvalidPaymentIdToken = 'invalid_payment_id_token',
  PaymentIdDoesNotExist = 'payment_id_does_not_exist',
  CaptchaConfig = 'captcha_config',

  InvalidVotesFormat = 'invalid_votes_format',
  InvalidSequenceId = 'invalid_sequence_id',
  InvalidEditionId = 'invalid_edition_id',
  InvalidRoundId = 'invalid_round_id',
  InvalidVoteAmount = 'invalid_vote_amount',
  InvalidDdi = 'invalid_ddi',
  TooManyVotes = 'too_many_votes',
  NotEnoughVotes = 'not_enough_votes',
  EditionConfigWrong = 'edition_config_wrong',

  SequenceAndFingerprintAlreadyExist = 'sequence_and_fingerprint_already_exist',
  SequenceAndParAlreadyExist = 'sequence_and_par_already_exist',
  CardOrWalletAlreadyVotedInSequence = 'card_or_wallet_already_voted_in_sequence',

  WebhookPriceMismatch = 'webhook_price_mismatch',
  WebhookCurrencyMismatch = 'webhook_currency_mismatch',
  WebhookCountryMismatch = 'webhook_country_mismatch',

  NonVotingSequence = 'non_voting_sequence',
  NonEligibleCardCountry = 'non_eligible_card_country',
  BlacklistedCountriesParsing = 'blacklisted_countries_parsing',
}

export const Errors = {
  ...PaymentPluginErrors,
  ...NvpErrors,
}

export const ErrorUserMessages = {
  ...PaymentPluginErrorUserMessages,
  ...NvpErrorUserMessages,
}
